'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');
var PanelHeader_module = require('./PanelHeader.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const PanelHeader = ({
  children
}) => {
  const {
    panelheaderNoneNone: panelHeaderStyle
  } = nthHookTheme.useTheme();
  return /*#__PURE__*/React__default["default"].createElement("h2", {
    className: PanelHeader_module["default"].panelHeader,
    style: panelHeaderStyle
  }, children);
};
var PanelHeader$1 = nthHookTheme.withThemeProvider(PanelHeader, {
  themeTokens: ['panelheaderNoneNone']
});

exports["default"] = PanelHeader$1;
